import React from 'react';
import { useHistory } from 'react-router-dom';
import { FirebaseUser, SessionHeader } from 'wavepaths-shared/core';

import { Features } from '@/features';

import { useAuthContext } from '../../../auth';
import { formatDateTime } from '../../../dateUtilsV2';
import {
    getAbsoluteSessionAnonymousRecordingLink,
    getAbsoluteSessionIntegrationLink,
    getAbsoluteSessionRecordingLink,
} from '../../../formUtils/formUtils';
import UserEvents, { CopiedSessionTab } from '../../../UserEvents';
import { renderSessionClients, renderSessionName } from '../helpers';
import SessionCard from '../SessionCard';
import { ShareClientLinkDialog } from '../SharePatientLinkDialog';
import { fetchExpirationInfo } from '../utils';

export interface Props {
    session: SessionHeader;
    isAdmin?: boolean;
    signups?: { [sessionId: string]: FirebaseUser[] };
}
const EndedSessionCard = ({ session, isAdmin }: Props): React.ReactElement => {
    const { isEnabled } = useAuthContext();
    let isIntegrationEnabled = isEnabled(Features.CLIENT_INTEGRATION);
    const history = useHistory();
    const sessionName = renderSessionName(session);
    const clientNames = renderSessionClients(session);

    const userInfoText = session?.user?.name;

    const onClickLog = () => {
        history.push(`/logs/${session.id}`);
    };

    const onClickDetails = () => {
        history.push(`/session/details/${session.id}`);
    };

    const handleMakeCopy = async () => {
        UserEvents.copiedSession(CopiedSessionTab.COMPLETED);
        window.location.href = `/session/copy/${session.id}`;
    };
    const sessionInfo = [`Created: ${formatDateTime(session.endedAt)}`];

    const { isExpired, expirationMessage } = fetchExpirationInfo(session);
    if (isExpired) {
        isIntegrationEnabled = false;
    }

    sessionInfo.push(`Expiration: ${formatDateTime(session.deleteRecordingAt)}`);

    return (
        <div>
            <SessionCard
                info={sessionInfo}
                title={sessionName}
                subtitle={clientNames}
                userInfoText={isAdmin && userInfoText ? userInfoText : undefined}
                primaryActionLabel={'Details'}
                primaryAction={onClickDetails}
                actionsComponent={
                    <>
                        {isIntegrationEnabled ? (
                            <>
                                <ShareClientLinkDialog
                                    linkText={'Share Recording Only'}
                                    linkUrl={getAbsoluteSessionRecordingLink(session.id)}
                                    anonymousLinkUrl={getAbsoluteSessionAnonymousRecordingLink(session.id)}
                                    clients={session.clients}
                                    belowHeaderInfoText={expirationMessage}
                                />
                            </>
                        ) : (
                            <></>
                        )}
                        {isIntegrationEnabled ? (
                            <ShareClientLinkDialog
                                linkText={'Share Recording + Integration Form'}
                                linkUrl={getAbsoluteSessionIntegrationLink(session.id)}
                                clients={session.clients}
                                belowHeaderInfoText={expirationMessage}
                            />
                        ) : null}
                    </>
                }
                actions={[
                    { description: 'Make A Copy', action: handleMakeCopy },
                    ...(isAdmin ? [{ description: 'Log', action: onClickLog }] : []),
                ]}
                // footer={
                //     <SessionAudioPlayer
                //         onPlay={() => UserEvents.completedSessionAudioPlayed({ sessionId: session.id })}
                //         broadcastIdentifier={session.broadcastIdentifier}
                //         errorContext="Ended Session"
                //     />
                // }
                subActions={[]}
            />
        </div>
    );
};

export default EndedSessionCard;
